import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, Grid } from '@mui/material';
import clsx from 'clsx';

const useStyles = makeStyles()(theme => ({
  formStyle: {
    borderRadius: '4px',
    border: `1px solid ${theme.palette.system.lightGrey}`,
    opacity: 1,
    background: `${theme.palette.system.lightGrey2} 0% 0% no-repeat padding-box`,
    paddingRight: '23px',
    marginBottom: '12px',
  },
  containerStyle: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  mainBodyContainer: {
    flexGrow: 1,
    flexDirection: 'column',
  },
  headerContainer: {
    fontSize: `16px !important`,
    margin: '12px',
    fontWeight: 'bold',
  },
  contentContainer: {
    flexDirection: 'row',
    flexGrow: 1,
    border: '1px solid #ccc',
    padding: '12px',
    margin: '0 12px 12px 12px',
    backgroundColor: theme.palette.common.white,
    borderRadius: '4px',
  },
}));

export const WrapperComponent = ({ icon, title, children, customContentClass }: { title: string; children?; icon?; customContentClass?; }) => {
  const { classes } = useStyles();

  return (
    <form className={classes.formStyle}>
      <Grid container classes={{ root: classes.containerStyle }}>
        <Grid container item classes={{ root: classes.mainBodyContainer }}>
          <Grid item classes={{ root: classes.headerContainer }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              {title} {icon}
            </Box>
          </Grid>
          <Grid container item  classes={{ root: clsx(classes.contentContainer, customContentClass) }}>
            <Grid container>
              <Grid item spacing={1} sx={{ display: 'contents' }}>
                {children}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};
